module.exports = __webpack_public_path__ + "static/media/young.2effb903.svg";